import { useEffect } from "react";
import { useBrand } from "../lib/brand";

// Adapte dynamiquement le titre d'onglet, les métadonnées et le manifest PWA selon la zone.
export function BrandMeta() {
  const { isEurope, name } = useBrand();

  useEffect(() => {
    const title = isEurope
      ? "Nold Go - Votre transport de confiance"
      : "Mboa Go — Taxis-motos Afrique Centrale";
    const description = isEurope
      ? "Nold Go vous connecte pour des courses et livraisons rapides et sûres en Europe"
      : "Mboa Go — Réservez un taxi-moto (bendskin) en toute confiance au Cameroun et en Afrique Centrale. Courses rapides, livraison de colis, paiement en FCFA (MTN & Orange Money).";
    document.title = title;

    const setMeta = (sel, val) => {
      const el = document.querySelector(sel);
      if (el) el.setAttribute("content", val);
    };
    setMeta('meta[name="apple-mobile-web-app-title"]', name);
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:site_name"]', name);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);

    // SEO double domaine : canonical + og:url + og:image alignés sur le domaine d'entrée.
    const host = (typeof window !== "undefined" && window.location.hostname) || "";
    const path = (typeof window !== "undefined" && window.location.pathname) || "/";
    const base = /noldgo\./i.test(host) ? "https://www.noldgo.com" : "https://www.bentskingo.com";
    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };
    setLink("canonical", base + path);
    setMeta('meta[property="og:url"]', base + path);
    setMeta('meta[property="og:image"]', base + "/og-image.jpg");
    setMeta('meta[name="twitter:image"]', base + "/og-image.jpg");

    // Ne pas indexer l'environnement de preview/test → évite « moto-africa… » dans Google.
    const isPreview = /emergentagent\.com$/i.test(host) || /\.emergent\.host$/i.test(host);
    setMeta('meta[name="robots"]', isPreview ? "noindex, nofollow" : "index, follow");

    // Nom officiel du site pour Google (par domaine) : Mboa Go (Afrique) / Nold Go (Europe).
    let ldSite = document.getElementById("ld-website");
    if (!ldSite) { ldSite = document.createElement("script"); ldSite.type = "application/ld+json"; ldSite.id = "ld-website"; document.head.appendChild(ldSite); }
    ldSite.textContent = JSON.stringify({ "@context": "https://schema.org", "@type": "WebSite", name, url: base + "/" });

    const manifest = document.querySelector('link[rel="manifest"]');
    if (manifest) manifest.setAttribute("href", isEurope ? "/manifest-europe.json" : "/manifest.json");

    const apple = document.querySelector('link[rel="apple-touch-icon"]');
    if (apple) apple.setAttribute("href", isEurope ? "/nold-icon.jpg" : "/apple-touch-icon.png");
  }, [isEurope, name]);

  return null;
}
